/*
These are the actions for the page.
Think of these as "event emitters" used by the components on the page.
*/

// import { Action } from 'redux';
import * as React from 'react';
import { Action, Dispatch } from 'redux';
import { ProfileViewModel } from '@models/Auth';
import { usersService } from '@services/UsersService';
import { PageViewModel } from '@models/common.models';
import { UsersState } from './users.reducer';

import { toast } from 'react-toastify';
import { ToastComponent, ToastType, ToastOptions } from '@common/components';
// import { actions } from 'react-redux-form';
// import { EscrowOfficeCombinedState } from './escrow-office.reducer';
// import { initialEscrowOffice } from './_components/escrow-office.component';
// import { cleanObject } from '../common/helpers.utils';

// We can use enums instead of type constants like in the example. This is a newer TS feature
export enum UsersActionType {
  SearchInit = 'SearchInit',
  SearchSuccess = 'SearchSuccess',
  SearchFailure = 'SearchFailure'
}

// This is defining the action definition for certain actions on the page.
// There may be multiple types of these on a given page.
// All properties should be readonly.

/********** Search **********/
export interface UsersSearchInitAction extends Action {
  readonly query: string | null;
  readonly type: UsersActionType.SearchInit;
}
export interface UsersSearchSuccessAction extends Action {
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly result: PageViewModel<ProfileViewModel>;
  readonly type: UsersActionType.SearchSuccess;
}
export interface UsersSearchFailureAction extends Action {
  readonly errorMessage: string;
  readonly type: UsersActionType.SearchFailure;
}

// Actions for each action type declared here.
// They should all return an action object.

/********** Search **********/
export const usersSearch = (pageNumber: number, pageSize: number, query: string | null) => {
  return async (dispatch: Dispatch<UsersState>) => {
    dispatch(usersSearchInit(query));
    try {
      let result: PageViewModel<ProfileViewModel> = await usersService.search(pageNumber, pageSize, query);
      dispatch(usersSearchSuccess(pageNumber, pageSize, result));
    } catch (e) {
      dispatch(usersSearchFailure(e.toString()));
    }
  };
};
export function usersSearchInit(query: string | null): UsersSearchInitAction {
  return {
    query: query,
    type: UsersActionType.SearchInit
  };
}
export function usersSearchFailure(errorMessage: string): UsersSearchFailureAction {
  toast.error(<ToastComponent type={ToastType.Error} message={errorMessage.toString()} />, ToastOptions.Error);

  return {
    errorMessage: errorMessage,
    type: UsersActionType.SearchFailure
  };
}
export function usersSearchSuccess(
  pageNumber: number,
  pageSize: number,
  result: PageViewModel<ProfileViewModel>
): UsersSearchSuccessAction {
  return {
    pageNumber: pageNumber,
    pageSize: pageSize,
    result: result,
    type: UsersActionType.SearchSuccess
  };
}

/********** Get **********/
/*
export const escrowOfficeGet = (id: number) => {
    return async (dispatch: Dispatch<EscrowOfficeCombinedState>) => {
        dispatch(escrowOfficeGetInit());
        try {
            var escrowOfficeVM = await escrowOfficeService.getDetail(id);
            escrowOfficeVM = cleanObject(initialEscrowOffice, escrowOfficeVM);
            dispatch(escrowOfficeGetSuccess(escrowOfficeVM.id));
            dispatch(actions.change('escrowOffice', escrowOfficeVM));
        } catch (e) {
            dispatch(escrowOfficeGetFailure(e.toString()));
        }
    };
};
export function escrowOfficeGetInit(): EscrowOfficeGetInitAction {
    return {
        type: EscrowOfficeActionType.GetInit,
    };
}
export function escrowOfficeGetSuccess(id: number): EscrowOfficeGetSuccessAction {
    return {
        type: EscrowOfficeActionType.GetSuccess,
        currentId: id,
    };
}
*/

/********** Save **********/
/*
export const escrowOfficeSave = (model: EscrowOfficeViewModel) => {
    return async (dispatch: Dispatch<EscrowOfficeCombinedState>) => {
        dispatch(escrowOfficeSaveInit());
        try {
            const id = await escrowOfficeService.saveDetail(model);
            dispatch(escrowOfficeSaveSuccess(id));
            if (model.id === 0) {
                dispatch(actions.reset('escrowOffice'));
            }
            dispatch(escrowOfficeGet(id));
        } catch (e) {
            dispatch(escrowOfficeSaveFailure(e.toString()));
        }
    };
};
export function escrowOfficeSaveInit(): EscrowOfficeSaveInitAction {
    return {
        type: EscrowOfficeActionType.SaveInit,
    };
}
export function escrowOfficeSaveSuccess(id: number): EscrowOfficeSaveSuccessAction {
    return {
        type: EscrowOfficeActionType.SaveSuccess,
        currentId: id
    };
}
export function escrowOfficeSaveFailure(errorMessage: string): EscrowOfficeSaveFailureAction {
    return {
        type: EscrowOfficeActionType.SaveFailure,
        errorMessage: errorMessage
    };
}

export function escrowOfficeGetFailure(errorMessage: string): EscrowOfficeGetFailureAction {
    return {
        type: EscrowOfficeActionType.GetFailure,
        errorMessage: errorMessage
    };
}
*/



// WEBPACK FOOTER //
// ./src/users/users.actions.tsx